import React from 'react';
import styled from 'styled-components';
import {popularProducts} from "../data";
import Product from "./Product";
import {useState,useEffect} from "react";
import axios from 'axios';

const Container=styled.div`

   display:flex;
   padding:20px;
   flex-wrap:wrap;
   justify-content:space-between;


`;




 function Products({all,cat,filter,sort}) {

  const [products,setProducts]=useState([]);
  const [filterProducts,setFilterProducts]=useState([]);


  useEffect(()=>{

   const getProducts = async ()=>{
     try{
          const res =await axios.get(
            cat
            ? `https://the-lama-shop.onrender.com/api/products?category=${cat}`
            : "https://the-lama-shop.onrender.com/api/products"
          );
         setProducts(res.data);
     }catch(err){
       console.log(err);
     }
   };
   getProducts();
 },[cat]);


useEffect(()=>{

   cat && setFilterProducts(
     products.filter((item)=>
       Object.entries(filter).every(([key,value])=>
            item[key].includes(value)
   )
 )
);
 },[products,cat,filter]);

 useEffect(()=>{

   if(sort === "newest"){

     setFilterProducts(prev=>
       [...prev].sort((a,b)=>a.createdAt - b.createdAt)
     );

   }else if(sort === "asc"){

     setFilterProducts(prev=>
       [...prev].sort((a,b)=>a.price - b.price)
     );

   }else{

     setFilterProducts(prev=>
       [...prev].sort((a,b)=>b.price - a.price)
     );

   }

 },[sort]);




  return (
    <Container>
        {(all === "yes")
        ?
        products.map(item =>(
        <Product
        item={item}
        key={item.id}/>
      ))
        : cat

          ? filterProducts.map(item =>(
          <Product
          item={item}
          key={item.id}/>
        ))
          : products.slice(7,19).map(item =>(
          <Product
          item={item}
          key={item.id}/>
        ))
      }
    </Container>
  );
}

export default Products;
